import { useCallback } from "react";
import useGetAllShopEmailTemplatesSuspense from "@babackapp/private-api-client/client/use-get-all-shop-email-templates";
import useUpsertEmailTemplate from "@babackapp/private-api-client/client/use-upsert-email-template";
import useCurrentShopSuspense from "./use-current-shop-suspense";
import { useTemplatesEditorConfig } from "../context/templates-editor-config-context";
import { prepareUpsertRequest } from "../lib/prepare-upsert-request";
import type { TemplateType } from "../types";
import { BlockEditorData } from "@babackapp/blocks-editor/types";

export function useDuplicateTemplate() {
  const { data: shop } = useCurrentShopSuspense();
  const { domain } = useTemplatesEditorConfig();
  const { data: templates = [] } = useGetAllShopEmailTemplatesSuspense(
    shop.id,
    domain,
  );
  const upsertTemplateMutation = useUpsertEmailTemplate(shop.id);

  const duplicateTemplate = useCallback(
    async (templateId: string) => {
      const templateToDuplicate = templates.find((t) => t.id === templateId);

      if (templateToDuplicate) {
        const { body } = prepareUpsertRequest({
          data: {
            content: templateToDuplicate.content as BlockEditorData,
            subject: templateToDuplicate.subject as Record<string, unknown>,
            preview: templateToDuplicate.preview as Record<string, unknown>,
            title: `${templateToDuplicate.title} (copy)`,
            type: (templateToDuplicate.type || "email") as TemplateType,
            assets: { uploads: {} },
            domain,
          },
        });

        return await upsertTemplateMutation.mutateAsync({
          requestBody: body,
        });
      }
    },
    [templates, upsertTemplateMutation, domain],
  );

  return duplicateTemplate;
}
